import { render, staticRenderFns } from "./P.vue?vue&type=template&id=0c7c7fef&"
import script from "./P.vue?vue&type=script&lang=js&"
export * from "./P.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports